import { useIsDocsAndExtractActive } from "core/model/careseekers";
import { Auction, DocsFormName, Patient } from "core/types";
import { createContext, ReactNode, useContext, useState } from "react";
import { RecareDocsModal } from "./Modal";

type RecareDocsContextType = {
  formModal: DocsFormName | null;
  setFormModal: (value: DocsFormName | null) => void;
};

const RecareDocsContext = createContext<RecareDocsContextType | undefined>(
  undefined,
);

type RecareDocsProviderProps = {
  children: ReactNode;
  auction: Auction;
  patient: Patient;
};

export const RecareDocsProvider = ({
  auction,
  children,
  patient,
}: RecareDocsProviderProps) => {
  const [formModal, setFormModal] = useState<DocsFormName | null>(null);

  return (
    <RecareDocsContext.Provider value={{ formModal, setFormModal }}>
      {children}
      <RecareDocsModal auction={auction} patient={patient} />
    </RecareDocsContext.Provider>
  );
};

export const useRecareDocsContext = (): RecareDocsContextType => {
  const { isDischargeLetterActive, isRedesignActive } =
    useIsDocsAndExtractActive();
  const context = useContext(RecareDocsContext);
  if (context === undefined) {
    if (isRedesignActive || isDischargeLetterActive) {
      throw new Error(
        "useRecareDocsContext must be used within a RecareDocsProvider",
      );
    }
    return { formModal: null, setFormModal: () => {} };
  }
  return context;
};
